import { Box, Button, Pagination, Table, TableBody, TableCell, TableHead, TableRow, Typography, useMediaQuery } from "@mui/material"
import { useState } from "react"
import { MainContainer } from "../../components/MainContainerComp"
import ScrollIndicatorsComp from "../../components/ScrollIndicatorsComp/ScrollIndicatorsComp"
import { useSameWidthAsPreviousElement } from "../../utils/hooks/useSameWidthAsPreviousElement"
import { theme } from "../../utils/theme"
import { IGangWayReportResultsData } from "./GangWayResultsData"
import { NoRecordsStyle, boldText, dispatchInfoTableStyle, halfWidth, paginationStyles, tableWrapper } from "./styled"

interface GangWayReportResultProps {
  data: IGangWayReportResultsData,
  date: string,
  onOpenClosePlateModal: (regId: number, board: string) => void,
}

export const GangWayReportsResults = ({ data, date, onOpenClosePlateModal }: GangWayReportResultProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [page, setPage] = useState<number>(1);
  const rowsPerPage = 10;
  const startIndex = (page - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const rows = data.details;
  const totalPages = rows ? Math.ceil(rows.length / rowsPerPage) : 0;
  const [elementRef] = useSameWidthAsPreviousElement();

  const onPageChange = (event: React.ChangeEvent<unknown>, page: number) =>
    setPage(page);

  return (
    <MainContainer hasGreyBg>
      <Typography 
        component={'div'} 
        variant='container' 
        data-automation="data-container"
      >
        <ScrollIndicatorsComp>
          <Table size="custom" sx={dispatchInfoTableStyle} data-automation="summary-table">
            <TableHead>
              <TableRow>
                <TableCell colSpan={2}>
                  <Typography sx={boldText} data-automation="tbl-header">Selected Date/Shift: {date} - {data.buttonDescription} Shift</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow data-automation="tbl-col-hdrs">
                <TableCell sx={halfWidth}>
                  <Typography sx={{ textAlign: 'right', fontWeight: 'bold' }}>Jobs/Employees</Typography>
                </TableCell>
                <TableCell sx={halfWidth}>
                  <Typography sx={boldText}>Counts</Typography>
                </TableCell>
              </TableRow>
              <TableRow data-automation="tbl-rows">
                <TableCell>
                  <Typography sx={{ textAlign: 'right' }}>Total Gangway Jobs Ordered</Typography>
                </TableCell>
                <TableCell>
                  <Typography>{data.totalJobs}</Typography>
                </TableCell>
              </TableRow>
              <TableRow data-automation="tbl-rows">
                <TableCell>
                  <Typography sx={{ textAlign: 'right' }}>Pending Jobs</Typography>
                </TableCell>
                <TableCell>
                  <Typography>{data.unfilled}</Typography>
                </TableCell>
              </TableRow>
              <TableRow data-automation="tbl-rows">
                <TableCell>
                  <Typography sx={{ textAlign: 'right' }}>Declared Employees</Typography>
                </TableCell>
                <TableCell>
                  <Typography>{data.totalDeclare}</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </ScrollIndicatorsComp>
      </Typography>
      {!data.details && <Box sx={tableWrapper}>
        <Typography sx={NoRecordsStyle} data-automation="no-records">
          No Records
        </Typography>
      </Box>}

      {data.details &&
        <Typography
          sx={{ mt: 2 }}
          component={'div'} 
          variant='container' 
          data-automation="data-container"
        >
          <ScrollIndicatorsComp>
            <Table size="custom" sx={dispatchInfoTableStyle} data-automation="details-table">
              <TableHead>
                <TableRow>
                  <TableCell colSpan={5}>
                    <Typography sx={{ textAlign: "left", fontWeight: "bold" }} data-automation="tbl-header">Details</Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow data-automation="tbl-col-hdrs">
                  <TableCell><Typography sx={boldText}>Employee</Typography></TableCell>
                  <TableCell><Typography sx={boldText}>Plate</Typography></TableCell>
                  <TableCell><Typography sx={boldText}>Working</Typography></TableCell>
                  <TableCell><Typography sx={boldText}>Declared</Typography></TableCell>
                  <TableCell><Typography sx={boldText}>Telephone</Typography></TableCell>
                </TableRow>
                {
                  (data.details || []).slice(startIndex, endIndex)?.map((details, d) => (
                    <TableRow key={d} data-automation="tbl-rows">
                      <TableCell>
                        <Typography>{details.employeeFullName}</Typography>
                        <Typography>
                          {details.regId} <Typography component={'span'}>{details.homePortCode}</Typography>
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {details.boardCode && <Button
                          variant="outlined"
                          onClick={() => onOpenClosePlateModal(details.regId, details.boardCode)}
                        >
                          {details.boardCode}{details.plateNumber}
                        </Button>}
                      </TableCell>
                      <TableCell><Typography>{details.working}</Typography></TableCell>
                      <TableCell><Typography>{details.isDeclare}</Typography></TableCell>
                      <TableCell><Typography>{details.telephoneNumber}</Typography></TableCell>
                    </TableRow>
                  ))
                }
              </TableBody>
            </Table>
            {totalPages > 1 && <Pagination
              ref={elementRef}
              sx={paginationStyles}
              onChange={onPageChange}
              color="primary"
              count={totalPages}
              variant="outlined"
              shape="rounded"
              size={isMobile ? 'small' : 'medium'}
            />}
          </ScrollIndicatorsComp>
        </Typography>}
    </MainContainer>
  )
}